import { useMemo } from 'react';
import type IGameSettings from '../../../types/models/IGameSettings';
import { useAppStore } from '../../../store/app/appStore';
import type { ITopWin } from '../types/topWins.types';

// For event handlers only — the render path must use useGameByKey.
export const findGameByKey = (gameKey: string): IGameSettings | undefined =>
  useAppStore
    .getState()
    .sections.flatMap((section) => section.games)
    .find((g) => g.gameKey === gameKey);

// Subscribes to the sections reference so the scan re-runs only when sections
// change identity. No useShallow on purpose — reference equality is the point.
export const useGameByKey = (gameKey: string): IGameSettings | undefined => {
  const sections = useAppStore((state) => state.sections);

  return useMemo(
    () => sections.flatMap((section) => section.games).find((game) => game.gameKey === gameKey),
    [sections, gameKey],
  );
};

// Stub for games not in the live catalog so the favorites store can record
// add/remove without the full metadata.
export const buildGameStub = (win: ITopWin): IGameSettings => ({
  name: win.gameName,
  gameKey: win.gameKey,
  jackpotName: null,
  minDenomination: new Map(),
  denominations: new Map(),
  order: 0,
  banners: {
    lobby: { rows: 1, cols: 1 },
    section: { rows: 1, cols: 1 },
  },
  maxPossibleBets: new Map(),
  minPossibleBets: new Map(),
});
